import { render, staticRenderFns } from "./ProductivityTable.vue?vue&type=template&id=2d821925&lang=pug"
import script from "./ProductivityTable.vue?vue&type=script&lang=js"
export * from "./ProductivityTable.vue?vue&type=script&lang=js"
import style0 from "./ProductivityTable.vue?vue&type=style&index=0&id=2d821925&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports